var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.large)?_c('a',{attrs:{"target":"_blank","href":"https://www.edamam.com/"}},[_c('v-img',{attrs:{"src":require('@/assets/Edamam_Badge.svg'),"contain":"","position":"center center","title":"Powered By Edamam"}})],1):_c('v-img',{staticClass:"ml-n2",attrs:{"max-width":"160","src":require('@/assets/Edamam_Badge.svg'),"title":"Powered By Edamam"}})
}
var staticRenderFns = []

export { render, staticRenderFns }